import { createContext, useContext, useEffect, useMemo } from "react";
import { useLocation } from "wouter";
import { localeFromPath, localizePath, stripLocale, type Locale } from "@shared/i18n";

const LocaleContext = createContext<{locale:Locale; path:string; switchLocale:()=>void}>({locale:"en",path:"/",switchLocale:()=>{}});

export function LocaleProvider({children}:{children:React.ReactNode}) {
  const [location,navigate] = useLocation();
  const locale = localeFromPath(location);
  const path = stripLocale(location);
  useEffect(()=>{ document.documentElement.lang=locale; document.documentElement.dir=locale==="ar"?"rtl":"ltr"; },[locale]);
  useEffect(()=>{ try { const saved=localStorage.getItem("qm-locale") as Locale|null; if((saved==="ar"||saved==="en")&&saved!==locale) navigate(localizePath(path,saved),{replace:true}); else if(!saved) localStorage.setItem("qm-locale",locale); } catch {} },[]);
  const value = useMemo(()=>({locale,path,switchLocale:()=>{const next=locale==="en"?"ar":"en";try{localStorage.setItem("qm-locale",next);}catch{}navigate(localizePath(path,next));}}),[locale,path,navigate]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
export const useLocale = () => useContext(LocaleContext);
